export const SPINNER_SIZE = 90; // in px
